import React, { useEffect, useState } from "react";
import { SelectInput, TextInput } from "../../components/common/ui/Inputs";
import Button from "../../components/common/ui/Button";
import Table from "../../components/common/table/Table";
import { history } from "../../_helpers";
import ExcelExport from "../../components/common/ui/Export/ExcelExport";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { facilityAction, masterActions } from "../../_store";
import ActiveUser from "../../assets/svg/active-user.svg";
import InActiveUser from "../../assets/svg/inactive-user.svg";
import CommonModal from "../../components/common/ui/NotificationModal/CommonModal";
import generateXlsx from "../../components/common/export/generateXlsx";
import CustomLoader from "../../components/common/ui/Loader";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import Swal from "sweetalert2";
import AddIcon from "../../assets/svg/btn_icons/create-btn-icon.svg";

function Facility() {
  const dispatch = useDispatch();
  const [showSearchFields, setShowSearchFields] = useState(false);

  // let navigate = useNavigate();
  const location = useLocation();
  const stateList = useSelector((x) => x?.master?.stateDrpList);
  let sorting = false;
  let PCRsorting = false;
  // Replace first object label
  const updatedstateList = stateList.map((stateList, index) => {
    if (index === 0) {
      return { ...stateList, label: "-- ALL --" }; // Replace the label of the first object
    }
    return stateList;
  });
  const facilityList = useSelector((x) => x?.facility?.facilityList);
  const facilitySearch = useSelector((x) => x?.facility?.facilitySearchData);
  const isPageReloading = useSelector((state) => state.master?.isPageReload);

  const facilityPCRDetails = useSelector(
    (x) => x?.facility?.facilityPCRDetails
  );
  const { podStatusOptions } = useSelector((state) => state.dropdownOptions);

  // const [facilitySearch, setFacilitySearch] = useState({
  //   facilityCode: "",
  //   facilityName: "",
  //   city: "",
  //   activeStatus: 2,
  //   stateNameID: 0,
  //   pageNo: 1,
  //   rowCountPerPage: 10,
  //   sortBy: "", //asc desc
  //   exportExcel: false,
  //   exportPDF: false,
  // });

  const [facilityPCR, setFacilityPCR] = useState({
    facilityID: 0,
    pageNo: 1,
    rowCountPerPage: 10,
    sortBy: "",
  });

  /* facility list */ // Search Filter data should be set. When we click back button from Add/Edit page.
  useEffect(() => {
    dispatch(facilityAction?.getFacilityList(facilitySearch))
      .then((result) => {
        if (result?.payload?.DataList?.length === 0) {
          const searchData = { ...facilitySearch };
          searchData.pageNo = 1;
          searchData.rowCountPerPage = 10;
          dispatch(facilityAction?.setFacilitySearch(searchData));
          dispatch(facilityAction.getFacilityList(searchData));
        }
      })
      .catch((err) => { });
  }, [facilitySearch.rowCountPerPage, facilitySearch.pageNo, isPageReloading]);

  /* PCR Data */
  useEffect(() => {
    if (facilityPCR > 0) {
      dispatch(facilityAction?.getPCRDetails(facilityPCR));
    }
  }, [facilityPCR]);

  /* facility PCR Details */
  useEffect(() => {
    if (facilityPCR?.facilityID === 0) return;
    dispatch(facilityAction?.getPCRDetails(facilityPCR));
  }, [
    facilityPCR?.facilityID,
    facilityPCR.rowCountPerPage,
    facilityPCR.pageNo,
  ]);

  useEffect(() => {
    dispatch(masterActions.GetStateList());
    dispatch(masterActions.LoadFacilityDropDown({ facilityID: 0, activeStatus: 1 }));
  }, []);

  const columns = [
    {
      name: "Code",
      key: "FacilityCode",
      selector: (row) => row.FacilityCode,
      cell: (row) => (
        <div
          onClick={() => navigateFacilityEdit(row.FacilityID)}
          className="Common_Link_Style"
        >
          {row.FacilityCode}
        </div>
      ),
      sortable: true,
    },
    {
      name: "Name",
      key: "FacilityName",
      selector: (row) => row.FacilityName,
      sortable: true,
    },
    { name: "City", key: "City", selector: (row) => row.City, sortable: true },

    {
      name: "State",
      key: "StateName",
      selector: (row) => row.StateName,
      sortable: true,
    },
    {
      width: "100px",
      name: "PCR Count",
      key: "PrivateConversationCount",
      selector: (row) => row.PrivateConversationCount,
      sortable: true,
      cell: (row) =>
        row?.PrivateConversationCount === 0 ? (
          row?.PrivateConversationCount
        ) : (
          <div
            className="Common_Link_Style"
            data-bs-toggle="modal"
            data-bs-target="#facility-pcr-modal"
            onClick={() => handlePCRCount(row)}
          >
            {row.PrivateConversationCount}
          </div>
        ),
    },
    {
      width: "80px",
      name: "Status",
      key: "ActiveStatus",
      selector: (row) => row.ActiveStatus,
      cell: (row) =>
        row.ActiveStatus === 1 ? (
          <div title="Active">
            <img src={ActiveUser} alt="active-user" className="in-icon-size" />
          </div>
        ) : (
          <div title="Inactive">
            <img
              src={InActiveUser}
              alt="in-active-user"
              className="in-icon-size"
            />
          </div>
        ),
      sortable: true,
    },
  ];

  const facilityPCRDetailsColumns = [
    {
      name: "Inmate ID",
      key: "InmateResidentID",
      selector: (row) => row.InmateResidentID,
      sortable: true,
    },
    {
      name: "Last Name",
      key: "LastName",
      selector: (row) => row.LastName,
      sortable: true,
    },
    {
      name: "First Name",
      key: "FirstName",
      selector: (row) => row.FirstName,
      sortable: true,
    },
    {
      name: "Frequency Type",
      key: "FrequencyTypeText",
      selector: (row) => row.FrequencyTypeText,
      sortable: true,
    },
  ];

  const navigateFacilityEdit = (facilityID) => {
    Swal?.close();
    history.navigate("/Admin/FacilityList/AddEdit", {
      state: { facilityID: facilityID },
    });
  };

  const handleRowPerPage = (page) => {
    const search = { ...facilitySearch };
    search.rowCountPerPage = page;
    search.pageNo = 1;
    dispatch(facilityAction?.setFacilitySearch(search));
  };

  const handlePageChange = (page) => {
    if (sorting) {
      sorting = false;
      return;
    }

    const search = { ...facilitySearch };
    search.pageNo = page;
    dispatch(facilityAction?.setFacilitySearch(search));
  };

  const handlePCRRowPerPage = (page) => {
    setFacilityPCR((prevState) => ({
      ...prevState,
      rowCountPerPage: page,
    }));
  };

  const handlePCRPageChange = (page) => {
    if (PCRsorting) {
      PCRsorting = false;
      return;
    }
    setFacilityPCR((prevState) => ({
      ...prevState,
      pageNo: page,
    }));
  };

  const handleSort = (column, sortDirection) => {
    if (!column?.key) return;
    sorting = true;
    // setFacilitySearch((prev) => {
    // const newSortOrder = prev.sortBy.includes(column.key)
    //   ? prev.sortBy.endsWith("asc")
    //     ? "desc"
    //     : "asc"
    //   : "asc";

    //   return {
    //     ...prev,
    //     sortBy: `${column.key} ${newSortOrder}`,
    //   };
    // });
    const search = { ...facilitySearch };
    const newSortOrder = search.sortBy.includes(column.key)
      ? search.sortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortBy = `${column.key} ${newSortOrder}`;
    dispatch(facilityAction?.setFacilitySearch(search));

    dispatch(
      facilityAction.getFacilityList({
        ...facilitySearch,
        sortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handlePCRSort = (column, sortDirection) => {
    if (!column?.key) return;
    PCRsorting = true;
    const search = { ...facilityPCR };
    const newSortOrder = search.sortBy.includes(column.key)
      ? search.sortBy.endsWith("asc")
        ? "desc"
        : "asc"
      : "asc";
    search.sortBy = `${column.key} ${newSortOrder}`;
    setFacilityPCR(search);

    dispatch(
      facilityAction?.getPCRDetails({
        ...facilityPCR,
        sortBy: `${column.key} ${newSortOrder}`,
      })
    );
  };

  const handlePCRCount = (row) => {
    if (row?.PrivateConversationCount === 0 || row?.FacilityID === 0) return;
    setFacilityPCR((prevState) => ({
      ...prevState,
      facilityID: row?.FacilityID,
    }));
  };

  const handleChange = (e, select, isOnblur) => {
    const search = { ...facilitySearch };
    if (select === "stateNameID" || select === "activeStatus") {
      // setFacilitySearch((prevState) => ({
      //   ...prevState,
      //   [select]: e?.value,
      // }));
      search.pageNo = 1;
      search.rowCountPerPage = 10;
      search[select] =
        select === "activeStatus" && e?.value != null
          ? e?.value
          : e?.value
            ? e?.value
            : select === "activeStatus"
              ? 2
              : 0;
      dispatch(facilityAction?.setFacilitySearch(search));
      // const updatedObj = {
      //   ...facilitySearch,
      //   [select]: e?.value,
      // };

      dispatch(facilityAction?.getFacilityList(search));
      return;
    }
    const { name, value } = e?.target;
    // setFacilitySearch((prevState) => ({
    //   ...prevState,
    //   [name]: value,
    // }));
    search[name] = value ? (isOnblur ? value.trim() : value) : "";
    dispatch(facilityAction?.setFacilitySearch(search));
  };

  const handleSearchReset = () => {
    const resetSearch = {
      facilityCode: "",
      facilityName: "",
      city: "",
      activeStatus: 2,
      stateNameID: 0,
      pageNo: 1,
      rowCountPerPage: 10,
      sortBy: "",
      exportExcel: false,
      exportPDF: false,
    };
    dispatch(facilityAction?.setFacilitySearch(resetSearch));
    // setFacilitySearch(resetSearch);
    dispatch(facilityAction?.getFacilityList(resetSearch));
  };

  const exportDocAsExcel = () => {
    let generateExcelColumns = [
      "Code",
      "Name",
      "City",
      "State",
      "PCR Count",
      "Status",
    ];

    const updateTotalRows = {
      ...facilitySearch,
      rowCountPerPage: facilityList?.TotalRecordCount,
      exportExcel: true,
      pageNo: 1,
      // sortBy : facilitySearch.sortBy.endsWith("asc")
      // ? facilitySearch.sortBy.replace("asc","desc")
      // : facilitySearch.sortBy.replace("desc","asc")
    };

    dispatch(facilityAction?.getFacilityList(updateTotalRows))
      .then((result) => {
        const dataList = result?.payload?.DataList;
        let exportData =
          result &&
          dataList?.map((obj) => ({
            Code: obj.FacilityCode,
            Name: obj.FacilityName,
            City: obj.City,
            State: obj.StateName,
            "PCR Count": String(obj.PrivateConversationCount),
            Status: obj.ActiveStatus === 1 ? "Active" : "Inactive",
          }));
        generateXlsx(exportData, generateExcelColumns, "Facility_List");
      })
      .catch((err) => {
        showToastNotification("Error in Export Data", "error");
      });
  };

  const exportExcelInmatePrivateConversationDetails = () => {
    let generateExcelColumns = [
      "Inmate ID",
      "Last Name",
      "First Name",
      "Frequency Type",
    ];
    const updatedFacilityPCRDetails = {
      ...facilityPCR,
      pageNo: 1,
      rowCountPerPage: facilityPCRDetails?.TotalRecordCount,
      exportExcel: true,
    };
    dispatch(facilityAction?.getPCRDetails(updatedFacilityPCRDetails))
      .then((result) => {
        const dataList = result?.payload?.DataList;
        let exportData =
          result &&
          dataList?.map((obj) => ({
            "Inmate ID": obj.InmateResidentID,
            "Last Name": obj.LastName,
            "First Name": obj.FirstName,
            "Frequency Type": obj.FrequencyTypeText,
          }));
        generateXlsx(exportData, generateExcelColumns, "FacilityInmatePCRList");
      })
      .catch((err) => {
        showToastNotification("Error in Export Data", "error");
      });
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    const search = { ...facilitySearch, pageNo: 1, rowCountPerPage: 10 };
    dispatch(facilityAction?.setFacilitySearch(search));
    dispatch(facilityAction?.getFacilityList(search));
  };

  const handleResetPageandRowCount = () => {
    setFacilityPCR((prevState) => ({
      ...prevState,
      rowCountPerPage: 10,
      pageNo: 1,
    }));
  };

  const toggleInformation = () => {
    setShowSearchFields((prev) => !prev);
  };

  const renderSearch = () => {
    return (
      <form onSubmit={(e) => handleSearchSubmit(e)}>
        <div className="row">
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="facilityCode"
                id="code"
                label="Code"
                value={facilitySearch?.facilityCode}
                handleChange={handleChange}
                placeholder="Enter Code"
                required={false}
                handleBlur={(e) => handleChange(e, "facilityCode", true)}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="facilityName"
                id="name"
                label="Name"
                value={facilitySearch?.facilityName}
                handleChange={handleChange}
                placeholder="Enter Name"
                required={false}
                handleBlur={(e) => handleChange(e, "facilityName", true)}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <TextInput
                name="city"
                id="city"
                label="City"
                value={facilitySearch?.city}
                handleChange={handleChange}
                placeholder="Enter City"
                required={false}
                handleBlur={(e) => handleChange(e, "city", true)}
              />
            </div>
          </div>

          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              {/* Status */}
              <SelectInput
                name="activeStatus"
                label="Status"
                options={podStatusOptions}
                value={facilitySearch?.activeStatus}
                handleChange={(e) => handleChange(e, "activeStatus")}
                isClearable={facilitySearch?.activeStatus !== 2}
                placeholder="Select Status"
              />
            </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4">
            <div className="form-floating mb-3">
              <SelectInput
                name="stateNameID"
                options={updatedstateList}
                isMulti={false}
                closeMenuOnSelect={true}
                isDisabled={false}
                isLoading={false}
                isClearable={facilitySearch?.stateNameID !== 0}
                label="State"
                placeholder="Select State"
                value={facilitySearch?.stateNameID}
                handleChange={(e) => handleChange(e, "stateNameID")}
              />
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-3 flex-wrap">
          <Button
            variant="primary"
            className="me-2"
            label={"SEARCH"}
            type={"submit"}
            status={"primary"}
            disabled={false}
            icon={"search"}
          />

          <Button
            variant="secondary"
            className="me-2"
            onClick={handleSearchReset}
            label={"RESET"}
            type={"button"}
            status={"secondary"}
            disabled={false}
            icon={"fa-solid fa-rotate-right"}
          />
        </div>
      </form>
    );
  };

  return (
    <>
      {facilityList?.loading && <CustomLoader />}
      <div className="facility">
        <div className="d-flex flex-wrap flex-column justify-content-center align-items-center position-relative">
          <div className="card shadow-sm b-r-all p-4 border border-dark-grey mt-3 w-100">
            {/* Mobile only (Below md breakpoint) */}
            <div className=" d-block d-md-none">
              <div
                className=" d-flex align-items-center justify-content-between"
                style={{ background: "transparent", cursor: "pointer" }}
                onClick={toggleInformation}
              >
                <h2 className="form_title_uppercase text-color">
                  FACILITY SEARCH
                </h2>
                <i
                  id="itagInformation"
                  className={`fa fa-angle-down ${showSearchFields ? "rotate" : ""
                    }`}
                  style={{ fontSize: "20px" }}
                ></i>
              </div>
            </div>
            {/* Mobile only (Below md breakpoint) */}
            <div className="d-block d-md-none mt-2">
              {showSearchFields && renderSearch()}
            </div>

            {/* Web only (Desktop and above) */}
            <div className="mb-3 d-none d-md-block">
              <h2 className="form_title_uppercase text-color">
                FACILITY SEARCH
              </h2>
            </div>
            {/* Web only (Desktop and above) */}
            <div className="d-none d-md-block">{renderSearch()}</div>
          </div>

          <div className="card  p-4 border border-dark-grey mt-3 w-100 b-r-all mb-2">
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 resp-space">
              <h2 className="form_title_uppercase text-color resp-space">
                Facilities LIST
              </h2>
              <div className="d-flex flex-wrap gap-3 align-items-center resp-space">
                <Button
                  variant="success"
                  className="me-2"
                  onClick={() => {
                    Swal?.close();
                    history.navigate("/Admin/FacilityList/AddEdit", {
                      state: { facilityID: 0 },
                    });
                  }}
                  // onClick={() =>
                  //   showToastNotification("Data Saved Successfully", "success")
                  // }
                  label="Add Facility"
                  type="button"
                  status="btn-label"
                  imgsrc={AddIcon}
                  disabled={false}
                //icon={"circle-plus"}
                />
                {facilityList?.DataList?.length > 0 && (
                  <ExcelExport handleExcelExport={exportDocAsExcel} />
                )}
              </div>
            </div>

            <Table
              columns={columns}
              data={facilityList?.DataList}
              pagination
              onChangeRowsPerPage={handleRowPerPage}
              onChangePage={handlePageChange}
              totalRowCount={facilityList?.TotalRecordCount}
              currentPage={facilitySearch?.pageNo}
              paginationPerPage={facilitySearch.rowCountPerPage}
              onSort={handleSort}
              serverSideSort
              sortColumn={facilitySearch.sortBy.split(" ")[0]}
              sortDirection={facilitySearch.sortBy.split(" ")[1]}
            />
          </div>
        </div>
        <CommonModal
          modalId="facility-pcr-modal"
          title="INMATE PRIVATE CONVERSATION DETAILS"
          //loader={facilityPCRDetails?.loading}
          handleCloseIcon={handleResetPageandRowCount} //for cross icons
          bodyContent={
            <>
              <div className="d-flex flex-wrap justify-content-end align-items-end mb-3">
                <div className="d-flex flex-wrap gap-3 align-items-right">
                  <ExcelExport
                    handleExcelExport={
                      exportExcelInmatePrivateConversationDetails
                    }
                  />
                </div>
              </div>

              <Table
                columns={facilityPCRDetailsColumns}
                data={facilityPCRDetails?.DataList}
                pagination
                onChangeRowsPerPage={handlePCRRowPerPage}
                onChangePage={handlePCRPageChange}
                totalRowCount={facilityPCRDetails?.TotalRecordCount}
                currentPage={facilityPCR?.pageNo}
                paginationPerPage={facilityPCR.rowCountPerPage}
                onSort={handlePCRSort}
                serverSideSort
                sortColumn={facilityPCR.sortBy.split(" ")[0]}
                sortDirection={facilityPCR.sortBy.split(" ")[1]}
              />
            </>
          }
          footerContent={
            <button
              className="btn button-primary"
              data-bs-dismiss="modal"
              onClick={() => {
                handleResetPageandRowCount();
              }}
            >
              Close
            </button>
          }
        />
      </div>
    </>
  );
}

export default React.memo(Facility);
